import { render } from "./HeroArea.vue?vue&type=template&id=8b1e0c48"
import script from "./HeroArea.vue?vue&type=script&lang=js"
export * from "./HeroArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__